import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const PRIORITY_COLORS = {
  low: 'bg-green-100 text-green-700',
  medium: 'bg-amber-100 text-amber-700',
  high: 'bg-red-100 text-red-700',
  critical: 'bg-purple-100 text-purple-700',
};

const STATUS_COLORS = {
  open: 'bg-blue-100 text-blue-700',
  in_progress: 'bg-amber-100 text-amber-700',
  completed: 'bg-green-100 text-green-700',
  resolved: 'bg-green-100 text-green-700',
};

const RelatedSnags = ({ snags, loading }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="bg-surface rounded-lg border border-border p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="AlertTriangle" size={16} className="text-accent" />
        <h3 className="text-sm font-semibold text-text-primary">{t('relatedSnags')}</h3>
        {snags?.length > 0 && (
          <span className="ml-auto text-xs bg-accent/10 text-accent px-2 py-0.5 rounded-full">
            {snags?.length}
          </span>
        )}
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-6">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-accent"></div>
        </div>
      ) : snags?.length === 0 ? (
        <p className="text-sm text-text-secondary text-center py-4">{t('noSnagsLinked')}</p>
      ) : (
        <div className="space-y-2">
          {snags?.map((snag) => (
            <button
              key={snag?.id}
              onClick={() => navigate(`/snags/${snag?.id}`)}
              className="w-full text-left flex items-start gap-3 p-3 rounded-lg border border-border hover:border-accent hover:bg-accent/5 transition-colors"
            >
              <div className="w-7 h-7 rounded-md bg-red-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="AlertCircle" size={13} className="text-red-500" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-text-primary truncate">{snag?.title}</p>
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  <span className={`text-xs px-1.5 py-0.5 rounded ${PRIORITY_COLORS?.[snag?.priority] || 'bg-gray-100 text-gray-600'}`}>
                    {snag?.priority}
                  </span>
                  <span className={`text-xs px-1.5 py-0.5 rounded ${STATUS_COLORS?.[snag?.status] || 'bg-gray-100 text-gray-600'}`}>
                    {snag?.status?.replace('_', ' ')}
                  </span>
                  {snag?.location && (
                    <span className="text-xs text-text-secondary truncate">{snag?.location}</span>
                  )}
                </div>
              </div>
              <Icon name="ChevronRight" size={14} className="text-text-secondary flex-shrink-0 mt-1" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RelatedSnags;
